import {ConstantsParser} from "../../../ConstantsParser";
export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content = {
        class: 'fas',
        icon: 'fa-star'
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    let iconClasses = (new ConstantsParser(this.iconClasses())).parse().join(' ')
    return `<i class="fa fa-star ${iconClasses}"/>`
  }

  classes() {
    return [
      {property: 'Display', value: 'FLEX'},
      {property: 'AlignItems', value: 'ALIGN_ITEMS_CENTER'},
      {property: 'JustifyContent', value: 'JUSTIFY_CENTER'},
    ]
  }

  iconClasses() {
    return [
      { property: 'IconSize', value: 'ICON_SIZE_LG' }
    ]
  }

  iconStyles() {
    return []
  }

  styles() {
    return []
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
      iconClasses: {
        desktop: this.iconClasses(),
        tablet: this.iconClasses(),
        phone: this.iconClasses(),
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles(),
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
    }
  }
}
